<template>
  <v-data-table
    class="files-table mt-n4"
    :items="files"
    :headers="activeHeaders"
    :loading="isProcessing"
    hide-default-footer
  >
    <template #no-data>
      <AppEmptyState
        class="py-4"
        title="Brak plików"
        subtitle="Nie zostały dodane jeszcze żadne pliki o wybranym statusie."
      />
    </template>

    <template #[`item.select`]="{item}">
      <v-checkbox
        v-model="selectedFiles"
        :value="item.id"
        hide-details
        class="ma-0"
        dense
      />
    </template>

    <template #[`item.filename`]="{item}">
      <a
        class="d-flex align-center"
        :href="item.url"
        target="_blank"
        :download="item.filename"
      >
        <div
          class="files-table__avatar"
          :style="item.mimeType.includes('image') && `background-image: url(${getUrl(item.url)})`"
          :class="item.mimeType.includes('image') ? 'bg-cover' : 'pa-2'"
        >
          <v-img
            v-if="!item.mimeType.includes('image')"
            src="@/assets/img/img-blank.svg"
          />
        </div>
        <span class="primary--text text-body-2 font-weight-medium">
          {{ item.filename }}
        </span>
      </a>
    </template>

    <template #[`item.timestamp`]="{item}">
      <span v-if="item.currentStatus === 'brief'">Przy zgłoszeniu</span>
      <span v-else>
        {{ item.timestamp * 1000 | timestamp }}
      </span>
    </template>

    <template #[`item.size`]="{item}">
      {{ getFileSize(item) }}
    </template>
  </v-data-table>
</template>

<script>
import AppEmptyState from '@/components/UI/AppEmptyState.vue';
import utils from '@/helpers/utils';
import { mapState } from 'vuex';

const headers = [
  {
    text: '', value: 'select', width: 40, sortable: false,
  },
  { text: 'Nazwa pliku', value: 'filename' },
  { text: 'Data', value: 'timestamp' },
  { text: 'Rozmiar', value: 'size' },
];

export default {
  props: {
    value: {
      type: Array,
      required: true,
    },
    files: {
      type: Array,
      required: true,
    },
    columns: {
      type: Array,
      required: false,
    }
  },

  components: {
    AppEmptyState,
  },

  computed: {
    ...mapState('project', [
      'isProcessing',
    ]),
    selectedFiles: {
      get() {
        return this.value;
      },
      set(value) {
        this.$emit('input', value);
      },
    },
    activeHeaders() {
      return this.columns ? headers.filter(header => this.columns.includes(header.value)) : headers
    }
  },

  methods: {
    getFileSize(file) {
      return utils.parseFileSize(file.size);
    },
    getUrl(url) {
      return encodeURI(url).replace(/[!'()*]/g, (c) => `%${ c.charCodeAt(0).toString(16)}`);
    },
    isFileSelected(file) {
      return this.value.includes(file.id);
    },
  },
};
</script>

<style lang="scss" scoped>
.files-table {
  background-color: $accent-grey;
  &::v-deep  {
    .v-data-table-header th {
      font-weight: 500;
      font-size: 12px;
      color: #535454 !important;
    }
    tr td {
      border: none !important;
    }
  }

  &__avatar {
    width:32px;
    height:32px;
    margin-right: 8px;
    background-color: #DDE3E3;
  }
}
::v-deep .v-application--is-ltr .v-input--selection-controls__input {
  margin-right: 0;
}
</style>
